export default __webpack_public_path__ + "static/media/googleplay-image.3969e68b.svg";